import gql from 'graphql-tag';

export default gql`
subscription {
    onCreateCampaign {
        __typename
        id
        name
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Campaigns/NewSubscription.js